import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button, FormControlLabel, Checkbox } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions'
import { SketchPicker } from 'react-color';
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';
import ContentLabelForm from '../content_label/ContentLabelForm';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    gridWrapper: {
        width: '80%'
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
    customInput: {
        color: 'blue',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});

class AssignmentForm extends Component {

    handleChange = field_name => event => {
        let value = ''
        if (field_name === 'Color') {
            value = event.hex
        }
        else {
            value = event.target.value;
            if (event.target.type === 'checkbox') {
                value = event.target.checked ? 1 : 0;
            }
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }
        this.props.runValidator(validator)
        this.props.updateAssignmentForm(update_data);
    }

    handleGradableChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }
        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }
        this.props.runValidator(validator)
        this.props.updateAssignmentForm(update_data);

        const resetMin = {
            ['MinScore']: 0
        }

        const resetMax = {
            ['TotalScore']: value === 1 ? 100: 0
        }
        this.props.updateAssignmentForm(resetMin);
        this.props.updateAssignmentForm(resetMax);
    }

    handleCopyClick = () => {
        this.props.toggleAssignmentRepull(true)
        return this.props.history.push('/assignment/edit/' + this.props.copiedAssignment.assignment_id)
    }

    render() {
        const { classes, view_type, assignment, validator } = this.props;

        return (
            <Grid container spacing={24}>
                <Grid item xs={5}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="AssignmentName"
                                label="Assignment Name"
                                value={assignment.header.AssignmentName}
                                onChange={this.handleChange('AssignmentName')}
                                error={validator.filter(v => v.field_name === 'AssignmentName')[0].error}
                                helperText={validator.filter(v => v.field_name === 'AssignmentName')[0].error_msg}
                                {...getSharedTextFieldProps(view_type, classes)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="AssignmentDescription"
                                label="Assignment Description"
                                value={assignment.header.AssignmentDescription}
                                onChange={this.handleChange('AssignmentDescription')}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={(assignment.header.AssignmentDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                multiline
                                rows="4"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container className={classes.gridWrapper}>
                                <Grid item xs={6}>
                                    <TextField
                                        id="MinScore"
                                        label="Score needed to Pass"
                                        value={Number(assignment.header.MinScore).toFixed(1)}
                                        onChange={this.handleChange('MinScore')}
                                        {...getSharedTextFieldProps(view_type, classes)}
                                        className={(assignment.header.MinScore === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                        type='number'
                                        inputProps={{
                                            min: 0,
                                            step: 1
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="TotalScore"
                                        label="Total Score"
                                        value={Number(assignment.header.TotalScore).toFixed(1)}
                                        onChange={this.handleChange('TotalScore')}
                                        {...getSharedTextFieldProps(view_type, classes)}
                                        className={(assignment.header.TotalScore === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                        type='number'
                                        inputProps={{
                                            min: 0,
                                            step: 1
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(assignment.header.Active === 1 || assignment.header.Active === true)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                        disableRipple={view_type === 'detail'}
                                        value="Active"
                                        color="primary"
                                    />
                                }
                                label="Active"
                            />
                        </Grid> */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(assignment.header.IsRequired === 1 || assignment.header.IsRequired === true)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleChange('IsRequired')}
                                        disableRipple={view_type === 'detail'}
                                        value="IsRequired"
                                        color="primary"
                                    />
                                }
                                label="Is Required to Pass Course"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(assignment.header.IsGradable === 1 || assignment.header.IsGradable === true)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleGradableChange('IsGradable')}
                                        disableRipple={view_type === 'detail'}
                                        value="IsGradable"
                                        color="primary"
                                    />
                                }
                                label="Requires Grading"
                            />
                            {view_type === 'detail' ?
                                <div style={{ maxWidth: '100px', marginLeft: '10px' }}>
                                    <div style={{ float: 'left', paddingTop: '7px' }}>Color:</div>
                                    <div style={{ float: 'right', width: '30px', height: '30px', borderRadius: '50%', background: assignment.header.Color }} ></div>
                                </div>
                                :
                                null
                            }
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: '20px' }}>
                            <ContentLabelForm
                                labelList={this.props.contentLabelList}
                                component_reference={'assignment'}
                                component_reference_id={assignment.header.assignment_id}
                                baseComponent={assignment}
                                updateFunction={this.props.updateAssignmentLabels}
                                view_type={view_type}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <ComponentTrackingInfo
                        editInfo={this.props.editInfo}
                        view_type={this.props.view_type}
                        classes={classes}
                    />
                    <TextField
                        id="Event Usage"
                        label="Event Usage"
                        value={this.props.event_usage.event_list.filter((event_info) => event_info.is_in_conflict).length > 0 ? `Save Conflicts (${this.props.event_usage.event_list.filter((event_info) => event_info.is_in_conflict).length})` : 'No Save Conflicts'}
                        {...getSharedTextFieldProps('detail', classes)}
                        hidden={this.props.view_type === 'create'}
                    />
                    {this.props.copiedAssignment && !this.props.paramHistory.active ?
                        <TextField
                            id="Copied Assignment Name"
                            label="Copied Assignment Name"
                            value={this.props.copiedAssignment.AssignmentName}

                            inputProps={{ className: classes.customInput, onClick: () => this.handleCopyClick() }}
                            {...getSharedTextFieldProps('detail', classes)}
                        />
                        :
                        null
                    }
                </Grid>
                <Grid item xs={3}>
                    {view_type === 'detail' ? null :
                        <SketchPicker
                            disabled={view_type === 'detail'}
                            color={assignment.header.Color}
                            onChangeComplete={this.handleChange('Color')}
                            disableAlpha={true}
                        />
                    }

                </Grid>
            </Grid>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAssignmentForm: Actions.updateAssignmentForm,
        runValidator: validatorActions.runValidator,
        toggleAssignmentRepull: Actions.toggleAssignmentRepull,
        updateAssignmentLabels: Actions.updateAssignmentLabels
    }, dispatch);
}

function mapStateToProps({ assignmentApp, auth, validator, paramHistory, contentLabelReducer }) {
    return {
        assignment: assignmentApp.assignments.currentAssignment,
        editInfo: assignmentApp.assignments.editInfo,
        copiedAssignment: assignmentApp.assignments.copiedAssignment,
        event_usage: assignmentApp.assignments.event_usage,
        validator: validator.list,
        paramHistory: paramHistory.courseBuilder,
        contentLabelList: contentLabelReducer.contentLabelReducer.contentLabelList,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignmentForm)));



// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentForm.js